import "./MainContent.css";
import {  MainGridLayout } from "../Grid";

const MainContent = (props) => {
    const containerStyle = {
        backgroundColor: "#eeeeee",
        marginLeft: props.isSidebarOpen ? "220px" : "0",
        width: props.isSidebarOpen ? "calc(100% - 220px)" : "100%",
    };
    return (
        <div className="main-content-container" style={containerStyle}>
            <MainGridLayout
                card={`grid`}
                id={props.id}
            />
        </div>
    );
};

export default MainContent;
